import { Injectable } from '@angular/core';
import { ColumnModel, GridComponent } from '@syncfusion/ej2-angular-grids';

@Injectable({
  providedIn: 'root'
})
export class CookiesService {

  constructor() { }

  public setCookiColumn(grid: GridComponent, cookieName: string){
    const cookie = grid.columns.map(column => ({
      field: column.field,
      visible: column.visible,
    }));
    const date = new Date();
    date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = `${cookieName}=${JSON.stringify(cookie)}; ${expires}; path=/`;
  }

  public applyCookies(grid: GridComponent, cookieName: string) {
    const cookie = document.cookie.split('; ').find(row => row.startsWith(cookieName + '='));
    if (cookie) {
      const cookieValue = cookie.split('=')[1];
      const cookieData = JSON.parse(cookieValue);

      const visibilityMap = new Map<string, boolean>();
      cookieData.forEach((col) => {
        if (col?.field) {
          visibilityMap.set(col.field, col.visible);
        }
      });

      for (let i = 0; i < grid.columns.length; i++) {
        const column = grid.columns[i] as ColumnModel;
        if (column.field && visibilityMap.has(column.field)) {
          column.visible = visibilityMap.get(column.field);;
        }
      }
    }
  }

  public getVisibilityMapFromCookie(cookieName: string): Map<string, boolean> {
    const cookie = document.cookie.split('; ').find(row => row.startsWith(cookieName + '='));
    const visibilityMap = new Map<string, boolean>();

    if (cookie) {
      const cookieValue = cookie.split('=')[1];
      try {
        const cookieData = JSON.parse(decodeURIComponent(cookieValue));
        cookieData.forEach((col) => {
          if (col?.field) {
            visibilityMap.set(col.field, col.visible);

          }
        });
      } catch (e) {
        console.warn('Invalid cookie format:', e);
      }
    }

    return visibilityMap;
  }



  public setCookie(cookieName: string, cookieValue: object){
    const cookie = cookieValue
    const date = new Date();
    date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = `${cookieName}=${JSON.stringify(cookie)}; ${expires}; path=/`;
  }

  public getCookie(cookieName: string){
    const cookie = document.cookie.split('; ').find(row => row.startsWith(cookieName));
    if (cookie) {
      return cookie.split('=')[1];
    }
    return null;
  }

  public deleteCookie(cookieName: string){
    document.cookie = `${cookieName}=; expires=Thu, 11 Jan 1991 00:00:00 UTC; path=/;`;
  }

  public forceReload(version){
    window.location.replace(window.location.pathname + '?new-version=' + version);
  }
}
